export default (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: `${theme.spacing(1)} !important`,
  },
  withoutLabel: {
    marginTop: `${theme.spacing(3)} !important`,
  },
  textField: {
    width: '100%',
  },
  signUpButton: {
    backgroundColor: '#FEC12C !important',
    width: '250px !important',
    height: '45px !important',
    marginTop: '20px !important',
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
    },
  },
});
